import * as React from "react";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import { ChiamaAPI, BottoneAPI, Trad, BaseComponent } from "../components/";
import { Contesto } from "../components/";
import { CommissionData, CopyType } from "../components/CommissionData";

interface IProvvigione {
    Dato: Dati.CRisAPIProvvigioni;
    Aggiornare: number;
}

export class Provvigione extends BaseComponent<Glob.IRouteGlobaleProps, IProvvigione> {
    private infoContesto: Dati.InfoContesto[] = [];

    public constructor(props: any) {
        super(props);
        let dato: Dati.CRisAPIProvvigioni = new Dati.CRisAPIProvvigioni();
        this.state = {
            Dato: dato,
            Aggiornare: 1
        };

        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
        this.OnCopyValues = this.OnCopyValues.bind(this);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIProvvigioni, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.setState({ Dato: dati });
        }
        return true;
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("STATI ERRORE"), dati.ErrTesto);
        } else {
            this.setState({ Aggiornare: this.state.Aggiornare + 1 });
            Glob.InfoModaleSuccess(Trad.Trad("PROVVIGIONI"), Trad.Trad("ProvvigioniAggiornateCorrettamente"));
        }
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        return this.state.Dato.Dati;
    }

    private CopyToEmptyFields = (valueToCopy: [], item: Dati.CProvvigioni): Dati.CProvvigioni => {
        const itemCommissionData: [] = JSON.parse(item.ProvvigioniJSON);

        itemCommissionData.map((el: any) => {
            const commissionType = Object.keys(el.Parametri)[0];

            if (!el.Parametri[commissionType]) {
                valueToCopy.forEach((val: any) => {
                    if (Object.keys(val.Parametri)[0] == commissionType) {
                        el.Parametri[commissionType] = val.Parametri[commissionType];
                        el.Funzione = val.Funzione;
                    }
                });
            }
        });
        item.ProvvigioniJSON = JSON.stringify(itemCommissionData);

        return item;
    };

    private OnCopyValues = (copiedItemIndex: number) => (type: CopyType): any => {
        const copiedValues: Dati.CProvvigioni[] = this.state.Dato.Dati;
        const valueToCopy = JSON.parse(this.state.Dato.Dati[copiedItemIndex].ProvvigioniJSON);

        copiedValues.map(item => {
            if (!type && item.ProvvigioniJSON != "{}") {
                this.CopyToEmptyFields(valueToCopy, item);
            }
            if (type && item[type] === copiedValues[copiedItemIndex][type]) {
                item.ProvvigioniJSON = copiedValues[copiedItemIndex].ProvvigioniJSON;
            }
            return item;
        });

        this.setState({
            Dato: {
                ...this.state.Dato,
                Dati: copiedValues
            }
        });
    };

    public render() {
        let Provvigioni: any[] = [];
        this.infoContesto = [];
        this.infoContesto.push(
            new Dati.InfoContesto(Trad.Trad("Binder"), "/api/binder/Contesto?ID_Binder=" + (this.props.match.params as any).ID_Binder, "/binder/" + (this.props.match.params as any).ID_Binder)
        );
        //console.warn("TIPI DI STATI: ", this.state.CambiStati.Tipi);
        for (let i: number = 0; i < this.state.Dato.Dati.length; i++) {
            Provvigioni.push(
                <div className="kt-form login-form__group form-group row" key={i}>
                    <div className={Glob.DimensioneCSS(4) + " col-form-label"}>
                        <label>{this.state.Dato.Dati[i].DenominazioneCompagnia}</label>
                    </div>
                    <div className={Glob.DimensioneCSS(4) + " col-form-label"}>
                        <label>{Trad.Trad(this.state.Dato.Dati[i].TipoRamo)}</label>
                    </div>
                    <div className={Glob.DimensioneCSS(4) + " col-form-label"}>
                        <label>{Trad.Trad(this.state.Dato.Dati[i].TipoProdotto)}</label>
                    </div>
                    <div className={Glob.DimensioneCSS(12) + " col-form-label"}>
                        <CommissionData
                            Id={"Dato.Dati[" + i + "].ProvvigioniJSON"}
                            Name={"Dato.Dati[" + i + "].ProvvigioniJSON"}
                            Valore={this.state.Dato.Dati[i].ProvvigioniJSON}
                            OnChange={this.OnChange}
                            OnCopyValues={this.OnCopyValues(i)}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div>
                <Contesto Id="InfoContesto" Info={this.infoContesto} Name="Contesto" OnChange={e => this.OnChange(e)} />
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <div className="kt-portlet__head-label">
                                <span className="kt-portlet__head-icon">
                                    <i className="fa fa-money-bill-wave"></i>
                                </span>
                                <h3 className="kt-portlet__head-label">{Trad.Trad("Provvigioni")}</h3>
                            </div>
                        </div>
                        <div className="portlet__head-tools">
                            <ul className="kt-portlet__nav"></ul>
                        </div>
                    </div>
                    <form className="was-validated kt-form login-form kt-form login-form--fit kt-form login-form--group-seperator-dashed">
                        <div className="kt-portlet__body">
                            <div className="form-group kt-form login-form__group row">
                                <div className={"col-lg-12 kt--align-right"}>
                                    <BottoneAPI
                                        Default={true}
                                        Testo={Trad.Trad("Salva")}
                                        URL="/api/Provvigione"
                                        Metodo="POST"
                                        OnClick={(s, d) => this.OnClickSalva(s, d)}
                                        OnInvio={s => this.OnInvioSalva(s)}
                                        OnErrore={(s, e) => this.OnErrore(s, e)}
                                        Visibile={this._Scrittura}
                                    />
                                </div>
                            </div>
                            {Provvigioni}
                        </div>
                    </form>
                </div>
                <ChiamaAPI
                    Aggiornare={this.state.Aggiornare}
                    URL={"/api/Provvigione?id_Binder=" + (this.props.match.params as any).ID_Binder}
                    Metodo="GET"
                    OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
                    OnErrore={this.OnErrore}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/Provvigione.tsx